<template>
  <router-view />
</template>

<script>
export default {
  
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Alike&display=swap');

* {
  padding: 0;
  margin: 0;
}
body {
  background: #070707;
  color: white;
  font-family: 'Alike', serif;
}
.clickable {
  cursor: pointer;
}
</style>
